import { useSelector } from "@/store";

export const useShowFooter = () =>
  useSelector((state) => state.app.bootstrap?.data?.config?.showFooter === "show");
